import { AutoTidStatusType, FilterColumn } from "types";

const loadOptions = () => ({
	options: AutoTidStatusType.getOptions(),
	hasMore: false,
});

const autoTidStatusColumn = (): FilterColumn => ({
	name: "autoTidStatus",
	type: "select" as const,
	loadOptions,
	getOptionLabel: option => option.displayName,
	getOptionValue: option => option.value,
	placeholder: "Auto TID Status",
});

export default autoTidStatusColumn;
